<template>
  <div class="customer-detail conmon-top">
    <el-container>
      <div
        style="margin: 20px auto 0;background: #F0F2F5;padding: 0;width: calc(100% - 40px); display: flex; justify-content:row;">
        <div>
          <div class="customer-left">
            <div class="main-info">
              <div class="head-img">
                <img :src="customerTmp.customer.image_001 | showImgUrl" alt="用户头像">
              </div>
              <div class="person-info">
                <div class="user-name">
                  <span v-if="customerTmp.customer.name_001 === ''">未知</span>
                  <span v-else>{{ customerTmp.customer.name_001 }}</span>
                </div>
                <div class="phone">
                  <img src="../../assets/images/link-man.png"
                    style="display: block;float: left;margin-top: 3px;margin-right: 4.5px;width: 13px;height: 14px;" />
                  <span v-if="customerTmp.customer.realname_001 === ''">未知</span>
                  <span v-else>{{ customerTmp.customer.realname_001 }}</span>
                </div>
                <div class="public">
                  <img src="../../assets/images/icn-shouji.png"
                    style="display: block;float: left;margin-top: 3px;margin-right: 4.5px;width: 13px;height: 14px;" />
                  <span v-if="customerTmp.customer.mobile_001 === ''">未知</span>
                  <span v-else>{{ customerTmp.customer.mobile_001 }}</span>
                </div>
              </div>
              <img src="../../assets/images/icn-binaji.png" class="edit-btn" @click="openDialog" />
            </div>
            <group-tags-template :dynamicGroupList="customer.customer.dynamicGroupList"
              :staticGroupList="staticGroupArray" :tags="tagsArray" @handleDeleteGroup="handleDeleteGroup"
              @handleDeleteTag="handleDeleteTag">
            </group-tags-template>
            <div class="person-info-title">资料详情</div>
            <customer-profile :attributeList="attributeList" :customer="customerTmp.customer"></customer-profile>

            <div class="customer-info">
              <div class="person-info-title" v-if="customer.customer.identitys.length > 0">
                客户身份
              </div>
              <div class="info-group" style="margin:20px" v-for="(item, index) in customer.customer.identitys"
                :key="index">
                <div class="weixin-img">
                  <img src="../../assets/images/weixin-1.png" alt="客户图片">
                  <!-- <img src="../../assets/images/weixin-3.png" alt="客户图片" v-if="item.type === 'wechat_unionid'"> -->
                </div>
                <div class="person-info-margin">
                  <div class="info-message" :title="item.value">
                    <span>身份信息：<span>{{ item.name }}</span></span>
                    <!-- <span v-if="item.type === 'wechat_unionid'">身份信息：<span>微信unionid</span> ({{ item.public_name }})</span> -->
                  </div>
                  <div class="info-message" :title="item.type">
                    <span>身份类型：{{ item.type }}</span>
                  </div>
                  <div class="info-message" :title="item.value">
                    <span>ID：{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--右侧-->
        <div class="customer-right">
          <!--等级和活跃度-->
          <div class="score-stage">
            <div class="stage">
              <div class="stage-icon">
                <img src="../../assets/images/store-icon-time.png" alt="等级图片">
              </div>
              <div class="stage-content">
                <div class="score-all score-item">
                  <p>当前等级
                    <el-tooltip class="item" effect="dark" :content="customer.customer.stage_explain" placement="right">
                      <i class="el-icon-question icon-rank"></i>
                    </el-tooltip>
                  </p>
                  <p>
                    <span style="color:#F89E34;font-size:16px">
                      {{ customer.customer.stage_id }}
                    </span></p>
                </div>
              </div>
            </div>
            <div class="score">
              <div class="score-icon">
                <img src="../../assets/images/group3.png" alt="积分图片">
              </div>
              <div class="score-all score-item">
                <p>客户价值评分</p>
                <p><span>{{ customer.customer.value_scoring }}</span></p>
              </div>
              <div class="score-item">
                <p>&nbsp;&nbsp;</p>
                <p>=</p>
              </div>
              <div class="score-datum score-item">
                <p>资料评分</p>
                <p><span>{{ customer.customer.score }}</span></p>
              </div>
              <div class="score-item">
                <p>&nbsp;&nbsp;</p>
                <p>+</p>
              </div>
              <div class="score-liveness score-item">
                <p>活跃度</p>
                <p><span>{{ customer.customer.activity }}</span></p>
              </div>
              <div class="line"></div>
              <div class="seven-liveness score-item">
                <p>7天活跃度</p>
                <p><span>{{ customer.customer.seven_activity }}</span></p>
              </div>
              <div class="thirty-liveness score-item">
                <p>30天活跃度</p>
                <p><span>{{ customer.customer.thirty_activity }}</span></p>
              </div>
            </div>
            <!-- <div class="stage">
              <div class="stage-icon">
                <img src="../../assets/images/icon-active.png" alt="等级图片">
              </div>
              <div class="stage-content">
                <div class="score-all score-item">
                  <p>活跃度</p>
                  <p>
                    <span style="color:#F89E34;font-size:16px">
                      {{ customer.customer.activity }}
                    </span></p>
                </div>
              </div>
            </div>
            <div class="stage">
              <div class="stage-icon">
                <img src="../../assets/images/icon-info.png" alt="等级图片">
              </div>
              <div class="stage-content">
                <div class="score-all score-item">
                  <p>资料评分</p>
                  <p>
                    <span style="color:#F89E34;font-size:16px">
                      {{ customer.customer.value_scoring }}
                    </span></p>
                </div>
              </div>
            </div> -->
          </div>
          <!--时间轴订单以及收货地址-->
          <div class="bottom-content">
            <div class="tabs">
              <div :key="index" v-for="(item, index) in tabs" class="tab-item" @click="changeTabs(index)">
                <span class="timeline-nav-name" :class="tabIndex == index ? 'active' : ''">{{ item.name }}</span>
              </div>
            </div>
            <div class="tab-contents">
              <div v-if="tabIndex === 0">
                <!-- <div class="search-record"> -->
                <!-- <div class="record">记录事件</div> -->
                <!-- <div class="search">
                    <i class="el-icon-search"></i>筛选
                  </div> -->
                <!-- </div> -->
                <div class="time-line">
                  <div class="day-item" v-for="(item, index) in customer.events.list" :key="index">
                    <div class="day-title-content clearfloat">
                      <div class="day-title" @click="closeDay(index)">
                        {{ item.dayName }}
                        <i class="el-icon-arrow-right" v-if="item.close === false"></i>
                        <i class="el-icon-arrow-down" v-if="item.close === true"></i>
                      </div>
                      <div :class="item.close === true ? 'day-item-smalls' : 'day-item-small'">
                        <div class="time-line-circle"></div>
                        <div v-if="item.close === false" class="total-event">
                          <div :key="j" v-for="(totalItem, j) in item.totalThings" class="event-things-content">
                            <!-- {{ totalItem.event_icon }} -->
                            <img :src="'/static/img/event-img/' + totalItem.event_icon" class="event-img">
                            <span class="event-content">{{ totalItem.event_name }}x{{ totalItem.event_num }}</span>
                          </div>
                          <span class="arrow-left-close"></span>
                        </div>
                      </div>
                    </div>
                    <template v-for="(one, i) in item.dayThings">
                      <div :key="i" v-if="item.close === true" class="time-item"
                        :class="one.event_identity === 'system' ? 'type-two' : 'type-one'"
                        style="display: flex; justify-content: row; flex-direction: flex-start;">
                        <div class="real-time">{{ one.join_date.timestamp | formatTime }}</div>
                        <div class="type-show"
                          :class="one.event_identity === 'system' ? 'type-two type-img' : 'type-one'">
                          <div class="type-show-line">
                            <img :src="'/static/img/event-img/' + one.icon" alt="" style="border-radius: 50%">
                            <!-- <div class="small-line-one" v-if="item.dayThings.length < 2"></div> -->
                            <div class="small-line"></div>
                          </div>
                        </div>
                        <div class="things-content" style="display:block">
                          <div class="things-content"
                            :class="one.event_identity === 'system' ? 'type-two type-spe' : 'type-one'"
                            :style="one.event_tags && one.event_tags.length > 0 ? 'border-bottom: 1px solid #E3E3E3;width:calc(100% - 40px);margin: 0 20px 14px;': 'width:calc(100% - 40px);margin: 0 20px 0px;'">
                            <div>
                              <p class="content-title">{{ one.title }}</p>
                              <p class="content-content" v-if="one.attr.length === 0">{{ one.content }}</p>
                              <p class="content-content">
                                <span v-for="(attrs, index) in one.attr"
                                  :key="index">{{attrs.name}}：{{attrs.value}}&nbsp;&nbsp;&nbsp;</span>
                              </p>
                            </div>
                            <div v-if="one.event_identity !== 'system'" class="score-content">
                              <span v-if="one.score > 0" style="display: flex; flex-direction: row;">
                                <span>
                                  <img src="../../assets/images/Shape.png" alt="活跃度" style="margin:0 5px">
                                </span>+
                              </span>{{ one.score }}
                            </div>
                            <div v-if="one.event_identity === 'system'" class="system-event">
                              <i class="iconfont icon-icon-shebeixinxi1" title="系统事件"></i>
                            </div>
                            <div class="arrow-left"></div>
                          </div>
                          <div v-if="one.event_tags && one.event_tags.length > 0"
                            style="    text-align: left;padding: 0px 20px 14px;">
                            <span v-for="item of one.event_tags" :key="item" class="content-dynamic-span"> {{item}}
                            </span>
                          </div>
                        </div>
                        <div class="clearfloat"></div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--编辑客户详情的弹窗-->
        <el-dialog class="cellDialog base-dialog edit-customer-detail" :title="'编辑' + useName" :visible.sync="adddialog"
          width="590px">
          <el-form class="model-item" ref="customer" :rules="rules" :model="customer.customer"
            style="height: 400px; overflow: auto;">
            <div v-for="(attr, index) in attributeList" :key="index">
              <el-form-item :prop="attr.identity" v-if="attr.isInner === 0" :label="attr.name + ':'"
                :label-width="addLabelWidth">
                <diy-model-template :type="attr.type" :attr="attr" v-model="customer.customer[attr.identity]"
                  :option='attr.option'>
                </diy-model-template>
              </el-form-item>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer" style="margin-top: 10px">
            <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
            <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="submitForm">确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </el-container>
  </div>
</template>

<script>
import { deleteStaticGroup, deleteByTags, getCusAddAttrList, getTerminalStoreDetail, editTerminalStoreDetail, updateTerminalStoreDetail, getMyAboutModelList, getCusTypes } from '@/api/set.js'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import DiyModelTemplate from '@/components/common/diy-model-template'
import GroupTagsTemplate from '@/components/common/group-tags-template'
import CustomerProfile from '@/components/common/customer-profile'
import { GROUP_TAG_OPTION_OBJ, GROUP_TAG_VALUE_OBJ, GROUP_TAG_FUN_KEY } from './constant'
export default {
  name: 'terminalDetail',
  data () {
    return {
      modelData: [],
      attrList: [],
      useName: this.$route.query.useName,
      storeDetails: {},
      orderList: [],
      regionData: regionDataPlus,
      selectedOptions: [],
      stages: [],
      stage: '',
      adddialog: false,
      addForm: {
        name: '',
        phone: '',
        sex: 1,
        mobile_verified: 1,
        niceName: '',
        stage_id: '',
        province: '',
        district: '',
        city: '',
        mobile: '',
        email: '',
        email_verified: 1,
        birthday: ''
      },
      addLabelWidth: '125px',
      intelligentData: [],
      aiGroup: [],
      aiGroupOptions: [],
      value4: [],
      tabs: [
        {
          icon: 'el-icon-share',
          name: '动态'
        }
      ],
      tabIndex: 0,
      timeLine: [],
      timeLineTotal: [],
      // 属性列表
      attributeList: [],
      // 客户属性
      customer: {
        customer: {
          avatar: '',
          image: '',
          identitys: [],
          dynamicGroupList: [],
          staticGroupList: [],
          tags: []
        },
        events: {
          list: []
        }
      },
      customerTmp: {
        customer: {
          avatar: '',
          image: '',
          identitys: []
        },
        events: {
          list: []
        }
      },
      customerInfo: [],
      customerType: {
        wechat: 'openid',
        wechat_unionid: 'unionid'
      },
      adressList: [],
      wait: true,
      tagsArray: [],
      staticGroupArray: []
    }
  },
  computed: {
    rules () {
      let rule = {}
      for (let item of this.attributeList) {
        if (item.type === 'input' || item.type === 'number') {
          rule[item.identity] = [
            { required: item.required === 1 ? true : false, message: '请输入' + item.name, trigger: 'blur' }
          ]
        }
        if (item.type === 'select' || item.type === 'multipleSelect' || item.type === 'model' || item.type === 'datePicker' || item.type === 'dateTimePicker' || item.type === 'addressPicker') {
          rule[item.identity] = [
            { required: item.required === 1 ? true : false, message: '请输入' + item.name, trigger: 'change' }
          ]
        }
      }
      return rule
    },
    profile () {
      let profile = {}
      for (let attr of this.attributeList) {
        let showField = attr.info.identity
        // if (attr.alias) {
        //   showField = attr.alias
        // }
        profile[attr.identity] = this.customer.customer[showField]
      }
      return profile
    }
  },
  filters: {
    diyAttr (value) {
      if (!Array.isArray(value)) {
        return value
      }
      return value.toString()
    }
  },
  components: {
    'diy-model-template': DiyModelTemplate,
    'group-tags-template': GroupTagsTemplate,
    'customer-profile': CustomerProfile
  },
  beforeRouteUpdate (to, from, next) {
    this.getAudiencesName(to.params.id, to)
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAudiencesName(to.params.id, to)
    })
  },
  methods: {
    //删除静态群组
    async handleDeleteGroup (groupId) {
      const { id, modelId } = this.$route.query
      const result = await deleteStaticGroup([modelId], [id], groupId)
      if (result.data.code == 200) {
        _g.toastMsg('success', '删除静态群组成功')
        this.handleFilterGroups(groupId)
      } else {
        _g.toastMsg('error', result.data.message)
      }
    },

    //删除静态标签
    async handleDeleteTag (tagId) {
      const { id, modelId } = this.$route.query
      const result = await deleteByTags(+modelId, id, tagId)
      if (result.data.code == 200) {
        _g.toastMsg('success', '删除标签成功')
        this.handleFilterTags(tagId)
      } else {
        _g.toastMsg('error', result.data.message)
      }
    },

    //前端控制不再显示静态群组中已删除的群组
    handleFilterGroups (id) {
      const list = this.staticGroupArray
      this.staticGroupArray = list.filter(ele => ele.id !== id)
    },
    //前端控制不再显示标签中已删除的标签
    handleFilterTags (id) {
      const list = this.tagsArray
      this.tagsArray = this.tagsArray.filter(ele => ele.id !== id)
    },

    // 获取列表名字
    getAudiencesName (modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.query.modelId
          for (let item of this.modelData) {
            if (item.id == id) {
              let arr = to.meta.routeArr
              arr[0].name = item.name + '管理'
              arr[0].Rpath = '/home/audiences-manage/' + this.$route.query.modelId
              arr[1].name = item.name + '详情'
              arr[1].Rpath = '/home/model-business?id=' + this.$route.query.id + '&modelId=' + this.$route.query.modelId + '&useName=' + this.useName
              console.log('arr[1].Repath', arr[1].Repath)
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    // 处理地址
    handleChange () { },
    load () {
      let id = this.$route.query.id
      let modelId = this.$route.query.modelId
      // 获取终端店详情
      let customerPro = getTerminalStoreDetail(modelId, id)
      let attrPro = editTerminalStoreDetail(modelId)
      Promise.all([customerPro, attrPro]).then(res => {
        let customer = res[0].data.result
        for (let item of customer.events.list) {
          item.close = false
        }
        let attrList = res[1].data.result
        // 处理地址
        for (let one of attrList) {
          // if (attr.alias) {
          //   showField = attr.alias
          // }
          if (one.type === 'addressPicker' && customer.customer[one.identity] !== undefined) {
            if (customer.customer[one.identity].code) {
              let array = customer.customer[one.identity].text
              customer.customer[one.identity] = customer.customer[one.identity].code
              if (array[0] !== '') {
                customer.customer[one.identity + '_text'] = array.toString()
              } else {
                customer.customer[one.identity + '_text'] = ''
              }
            } else {
              customer.customer[one.identity] = {}
            }
          }
          if (one.options !== '' && one.type !== 'model' && one.type !== 'input') {
            // 解析json 捕获异常
            try {
              one.option = JSON.parse(one.options)
            } catch (error) {
              console.log(error)
            }
          }
          // 处理modeL类型回显啊
          if (one.type === 'model' && JSON.parse(one.options).length > 0) {
            customer.customer[one.identity] = one.identity
            let modelId = JSON.parse(one.options)[0].modelId
            let identity = JSON.parse(one.options)[2].identity
            getMyAboutModelList(modelId, identity, '').then((res) => {
              if (res.data.code == 200) {
                one.option = res.data.result.list
                let array = customer.customer[one.identity]
                customer.customer[one.identity + 'model'] = array
                if (one.type === 'model' && one.options && customer.customer[one.identity + '_ids']) {
                  let idArray = customer.customer[one.identity + '_ids']
                  let idarr = []
                  for (let it of idArray) {
                    if (it.value !== '') {
                      idarr.push(it.id)
                      one.option.push(it)
                    }
                  }
                  customer.customer[one.identity] = idarr
                }
                if (!customer.customer[one.identity]) {
                  customer.customer[one.identity] = []
                }
              }
            })
          }
          if (one.type === 'multipleSelect' && one.options) {
            let optionsArr = JSON.parse(one.options)
            if (customer.customer[one.identity]) {
              let multipleArr = customer.customer[one.identity]
              customer.customer[one.identity + 'multipleSelect'] = multipleArr
              let multipleArray = multipleArr.split(',')
              let tmp = []
              for (let o of multipleArray) {
                for (let t of optionsArr) {
                  if (o === t) {
                    tmp.push(t)
                  }
                }
              }
              customer.customer[one.identity] = tmp
            }
          }
          if (one.type === 'addressPicker' && customer.customer[one.identity] === undefined) {
            customer.customer[one.identity] = one.identity
            customer.customer[one.identity] = {}
          }
          if (one.type === 'number' && customer.customer[one.identity] === undefined) {
            customer.customer[one.identity] = one.identity
            customer.customer[one.identity] = 0
          }
          if (customer.customer[one.identity] === undefined) {
            customer.customer[one.identity] = one.identity
            customer.customer[one.identity] = ''
          }
          if (one.type === 'multipleSelect') {
            customer.customer[one.identity] = one.identity
            customer.customer[one.identity + 'multipleSelect'] = ''
            customer.customer[one.identity] = []
          }
        }
        if (customer.customer.stage_id === '') {
          customer.customer.stage_id = '未知'
        }
        this.attributeList = attrList
        this.customer = customer
        this.customerTmp = JSON.parse(JSON.stringify(customer))
        const { tags, staticGroupList } = customer.customer
        this.tagsArray = tags
        this.staticGroupArray = staticGroupList
      })
    },
    // 提交编辑
    submitForm () {
      this.$refs.customer.validate((valid) => {
        if (valid) {
          this.updateTerminalStoreAction()
        } else {
          return false
        }
      })
    },
    updateTerminalStoreAction () {
      let aud = JSON.parse(JSON.stringify(this.customer.customer))
      for (let item of this.attributeList) {
        for (let key in aud) {
          if (item.type === 'addressPicker') {
            if (item.identity === key && aud[key]) {
              let codes = aud[key]
              if (codes.length === 1) {
                aud[key] = {
                  code: codes,
                  text: [CodeToText[codes[0]]]
                }
              }
              if (codes.length === 2) {
                aud[key] = {
                  code: codes,
                  text: [CodeToText[codes[0]], CodeToText[codes[1]]]
                }
              }
              if (codes.length === 3) {
                aud[key] = {
                  code: codes,
                  text: [CodeToText[codes[0]], CodeToText[codes[1]], CodeToText[codes[2]]]
                }
              }
              if ((codes.length === 0 && aud[key].text[0] !== '全部') || (codes.length === 1 && codes[0] === '' && aud[key].text[0] !== '全部')) {
                aud[key] = {}
              }
            }
            delete aud[item.identity + '_text']
          }
          if (item.type === 'number') {
            if (item.identity === key) {
              if (aud[key] === '') {
                aud[key] = 0
              }
              aud[key] = parseInt(aud[key])
            }
          }
          if (item.type === 'model') {
            if (item.identity === key) {
              delete aud[item.identity + '_ids']
              delete aud[item.identity + 'model']
              let arr = aud[key]
              if (arr === '') {
                arr = []
              }
              if (arr.constructor === String) {
                arr = arr.split(',')
              }
              aud[key] = {
                'modelId': JSON.parse(item.options)[0].modelId,
                'relationAttrId': JSON.parse(item.options)[1].attrId,
                'relationDataList': arr
              }
            }
          }
        }
      }
      // 添加弹窗
      this.isDisabled = true
      let id = this.$route.query.id
      let modelId = this.$route.query.modelId
      updateTerminalStoreDetail(modelId, id, aud).then((res) => {
        if (res.data.code == 200) {
          this.adddialog = false
          this.isDisabled = false
          setTimeout(() => {
            this.load()
          }, 2000)
          _g.toastMsg('success', '编辑成功')
        } else {
          this.isDisabled = false
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 打开编辑弹窗
    openDialog () {
      this.adddialog = true
    },
    // 右侧选项卡
    changeTabs (index) {
      this.tabIndex = index
    },
    // 开关时间轴的日期
    closeDay (index) {
      if (this.customer.events.list[index].close === false) {
        this.customer.events.list[index].close = true
      } else {
        this.customer.events.list[index].close = false
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/home/customer-manage') {
      to.meta.keepAlive = true
    } else {
      to.meta.keepAlive = false
    }
    next()
  },
  created () {
    this.load()
  }
}
</script>

<style scoped>
.info-group {
  height: 100px;
  background: #e7e7e7;
}
.weixin-img {
  width: 20px;
  float: right;
  display: flex;
  justify-content: center;
}
.weixin-img img {
  width: 20px;
  height: 20px;
  display: block;
}
.info-message {
  font-size: 12px;
  font-weight: 400;
  color: #333;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media only screen and (max-width: 1450px) {
  .stage .stage-icon {
    width: 60px;
    height: 60px;
  }
  .score .score-icon {
    width: 60px;
    height: 60px;
    margin-left: 5px;
  }
  .stage-content .stage-day,
  .stage-content .stage-now {
    display: flex;
    flex-direction: row;
  }
  .score-stage .stage-content {
    display: flex;
    flex-direction: column;
  }
  .stage-content .stage-day span,
  .stage-content .stage-now span {
    font-size: 14px;
    margin-left: 5px;
  }
}
.stage-content {
  display: flex;
  flex-direction: row;
}
.person-info-title {
  font-size: 14px;
  color: #333;
  margin-top: 21px;
  text-align: left;
  padding-left: 18px;
  font-weight: bold;
}
.goods-price {
  float: right;
}
.goods-left {
  width: 25%;
  height: 50px;
}
.order-item {
  width: 100%;
  height: auto;
  line-height: 50px;
}
.order-item-info {
  width: 100%;
  height: 50px;
  color: #666;
}
.order-time {
  width: 25%;
  float: left;
  height: 50px;
  font-size: 14px;
}
.order-main-info {
  width: 71%;
  float: left;
  height: 50px;
  padding: 0 2%;
}
.goods-main-info {
  float: right;
  width: 69%;
  height: 50px;
  padding: 0 2%;
  background: #ecf0f7;
  margin-right: 2%;
}
.order-store {
  float: left;
  font-size: 14px;
}
.order-money {
  float: right;
}
.order-goods-info {
  width: 100%;
  height: 50px;
  margin-bottom: 10px;
  color: #999;
  font-size: 14px;
}
::-webkit-scrollbar {
  width: 6px; /*滚动条宽度*/
  height: 16px; /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5; /*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px; /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc; /*滚动条的背景颜色*/
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.main-info {
  min-width: 240px;
  margin: 0 auto;
  height: 160px;
  border-bottom: 1px solid #dedede;
  background: #fff;
  position: relative;
}
.customer-info {
  min-width: 300px;
  padding-top: 12px;
  background: #fff;
  position: relative;
  width: 30%;
}
.customer-left {
  width: 300px;
  background: #fff;
  padding-bottom: 5px;
  border: 1px solid #e7e9f0;
  border-bottom: none;
}
.edit-btn {
  display: block;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 13px;
  right: 3px;
  cursor: pointer;
  background: none;
  padding: 0;
  margin-right: 15px;
}
.edit-btn:hover {
  background-color: #fff;
}
.head-img {
  width: 96px;
  height: 100%;
  float: left;
  display: flex;
  justify-content: center;
}
.head-img img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: block;
  margin-top: 33px;
}
.person-info {
  width: calc(100% - 96px);
  float: left;
  height: 100%;
  text-align: left;
  box-sizing: border-box;
}
.person-info-margin {
  width: 100%;
  float: left;
  text-align: left;
  box-sizing: border-box;
  margin: 0px auto;
  color: #f5f7fa;
  padding-left: 10px;
}
.user-name {
  font-size: 18px;
  color: #333;
  margin-top: 29px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.phone {
  margin-top: 12px;
}
.public {
  margin-top: 10px;
}
.phone,
.public {
  font-size: 14px;
  color: #333;
}
.intelligent .title,
.intelligent-special .title {
  height: 20px;
  line-height: 20px;
  color: #333;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
  margin-left: 18px;
  margin-top: 27px;
}
.intelligent .content,
.intelligent-special .content {
  line-height: 34px;
  color: #333;
  font-size: 16px;
  text-align: left;
  margin-left: 18px;
  margin-top: 8px;
}
.customer-info-item {
  width: calc(50% - 65px);
  margin: 0 auto;
  color: #333;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  border-bottom: none;
}
.info-item span:first-child {
  color: #666;
  font-size: 12px;
}
.customer-right {
  margin-left: 20px;
  width: calc(100% - 40px);
}
.score-stage {
  width: 100%;
  height: 140px;
}
.stage {
  width: 22%;
  height: 140px;
  float: left;
  background: #fff;
  display: flex;
  justify-content: space-around;
  flex-direction: flex-start;
  border: 1px solid #e7e9f0;
  align-items: center;
}
.stage-icon {
  width: 80px;
  height: 80px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
  border-radius: 0;
}
.stage-icon img {
  width: 100%;
  display: block;
  height: 100%;
}
.stage-day p,
.stage-now p {
  color: #999;
  font-size: 14px;
}
.stage-day p span {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
.stage-now p span {
  color: #f8a136;
  font-size: 16px;
  font-weight: bold;
}
.score {
  width: calc(78% - 20px);
  height: 140px;
  float: right;
  background: #fff;
  border: 1px solid #e7e9f0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.score-icon {
  width: 80px;
  height: 80px;
  border-radius: 0;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}
.score-icon img {
  width: 100%;
  display: block;
  height: 100%;
}
.score-item p {
  color: #999;
  font-size: 14px;
}
.score-item p span {
  color: #333;
  font-size: 20px;
  font-weight: bold;
}
.thirty-liveness {
  position: relative;
}
.line {
  width: 1px;
  height: 80px;
  background: #e7e7e7;
}
.bottom-content {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #e7e9f0;
  padding-bottom: 10px;
}
.tabs {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  border-bottom: 1px solid #e7e9f0;
}
.tabs .tab-item {
  width: 180px;
  height: 40px;
  float: left;
  margin-right: 6px;
  background: #fff;
  color: #8e919d;
  line-height: 38px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.tab-contents {
  background: #fff;
  margin-top: 10px;
  padding-bottom: 50px;
  height: auto;
  /*overflow-y: auto;*/
}
.tabs .active {
  background: #fff;
  color: #1890FF;
  border-bottom: 2px solid #1890FF;
}
.timeline-nav-name {
  width: 80px;
  height: 40px;
  line-height: 40px;
  display: block;
  margin: 0 auto;
}
.search-record {
  height: 30px;
  line-height: 30px;
  color: #60c6cf;
  font-size: 14px;
  padding-top: 10px;
}
.search {
  width: 60px;
  height: 20px;
  margin-top: 5px;
  line-height: 20px;
  float: right;
  margin-right: 10px;
  border-right: 1px solid #ccc;
  cursor: pointer;
}
.record {
  float: right;
  cursor: pointer;
  margin-right: 10px;
}
.day-title-content {
  width: 90%;
  margin: 0 auto;
}
.day-item {
  height: auto;
  /*height: 998px;
  overflow-y: auto;*/
}
.day-title {
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #000;
  float: left;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.day-title i {
  color: #000;
}
.day-line {
  width: 2px;
  height: 40px;
  background: #e7e7e7;
  position: absolute;
  bottom: -80%;
  left: 13px;
  margin-left: -7px;
  margin-bottom: -7px;
}
.total-event {
  /*width: calc(100% - 220px);*/
  height: auto;
  background: #f0f3f6;
  float: left;
  margin-left: 30px;
  margin-top: 12px;
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  box-sizing: content-box;
}
.total-event div {
  width: 185px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #666;
  text-align: left;
  padding-left: 20px;
}
.day-item-small {
  width: calc(100% - 161px);
  height: auto;
  float: left;
  margin-left: 39px;
  padding-bottom: 10px;
  position: relative;
  border-left: 2px solid #e7e7e7;
  box-sizing: content-box;
}
.day-item-smalls {
  width: calc(100% - 161px);
  height: auto;
  float: left;
  margin-left: 39px;
  padding-bottom: 30px;
  position: relative;
  border-left: 2px solid #e7e7e7;
}
.time-line-circle {
  width: 12px;
  height: 12px;
  background: #e7e7e7;
  position: absolute;
  left: -7px;
  top: 8px;
  border-radius: 50%;
}
.time-item {
  width: 90%;
  margin: 0 auto 0px;
  height: 100%;
}
.clearfloat {
  clear: both;
}
.real-time {
  font-size: 14px;
  color: #808491;
  width: 120px;
  float: left;
  height: 30px;
  margin-top: 0px;
  line-height: 30px;
  text-align: right;
}
.type-show {
  width: 80px;
  float: left;
  margin-top: -20px;
}
.type-one {
  /*height: 80px;*/
}
.type-two {
  height: 80px;
}
.type-spe p:first-child {
  margin-top: 20px;
}
.type-spe .arrow-left {
  top: 10px;
}
.arrow-left-close {
  display: block;
  position: absolute;
  height: 0px;
  width: 0px;
  border-top: 0px solid transparent;
  border-right: 10px solid #f5f5f5;
  border-bottom: 16px solid transparent;
  left: -10px;
  top: 0px;
}
.type-img .type-show-line img {
  top: 0;
}
.type-show-line {
  width: 2px;
  height: 100%;
  background: #e7e7e7;
  position: relative;
  margin: 0 auto;
}
.small-line {
  width: 2px;
  height: auto;
  background: #e5e5e5;
  position: absolute;
  /*bottom: -20px;*/
  left: 50%;
  margin-left: -1px;
  /*z-index: 200;*/
}
.small-line-one {
  width: 2px;
  height: 150px;
  background: #e5e5e5;
  position: absolute;
  left: 50%;
  margin-left: -1px;
}
.type-show-line img {
  position: absolute;
  display: block;
  top: 20px;
  left: 50%;
  width: 40px;
  margin-left: -20px;
  z-index: 20;
  background: #fff;
}
.things-content {
  width: calc(100% - 200px);
  float: left;
  background: #f0f3f6;
  display: flex;
  justify-content: space-between;
  position: relative;
  height: auto;
  margin-bottom: 10px;
  margin-top: 10px;
}
.content-dynamic-span {
  background-color: #a7c7eb;
  color: #ffffff;
  padding: 4px 5px;
  border-radius: 5px;
  margin-top: 5px;
  margin-right: 12px;
  font-size: 12px;
}
.arrow-left {
  position: absolute;
  height: 0px;
  width: 0px;
  border-top: 0px solid transparent;
  border-right: 10px solid #f5f5f5;
  border-bottom: 16px solid transparent;
  left: -10px;
  top: 0px;
}
.content-title {
  font-size: 14px;
  color: #333;
  text-align: left;
  /*margin-left: 20px;*/
  line-height: 20px;
  margin-top: 18px;
  margin-bottom: 5px;
}
.content-content {
  font-size: 12px;
  color: #666;
  text-align: left;
  /*margin-left: 20px;*/
  line-height: 20px;
  margin-top: 6px;
}
.content-content span {
  width: 230px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.score-content {
  font-size: 14px;
  color: #333;
  text-align: center;
  margin: 10px 0px 0 0;
  display: flex;
  justify-content: row;
}
.system-event {
  padding: 0 10px;
  font-size: 14px;
  color: #059baa;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 10px 10px 0 0;
  border-radius: 3px;
}
.adress-content-item {
  margin-bottom: 0px;
  text-align: left;
  margin-left: 20px;
  color: #333;
  height: 30px;
}
.adress-item {
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  color: #333;
  padding-bottom: 10px;
  padding-top: 10px;
  background-color: #f5f7fa;
  border-radius: 5px;
}
.adress-item .el-form-item {
  margin-bottom: 0px;
}
.indynamic-group .el-input__inner {
  width: auto !important;
}
.tag-content {
  margin-left: 15px;
  margin-right: 15px;
  max-width: 230px;
}
.tag-span-look {
  display: inline-block;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
  height: 20px;
  line-height: 20px;
  padding: 5px;
  margin: 5px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tags-content-look {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  width: 130px;
}
.event-things-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.event-img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0;
  margin-top: 7px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 5px;
}
.event-content {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  width: 175px;
}
.event-content-one {
  font-size: 13px;
  margin-left: 20px;
  color: #666;
}
.time-line {
  padding-bottom: 20px;
  height: 990px;
  overflow-y: auto;
}
.item-dengji {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  /* width: 140px; */
}
.item-dengji p {
  width: 100%;
  text-align: center;
}
</style>
